import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import ChangePassword from 'pages/authentication/ChangePassword';
import PaymentForm from 'pages/kithome/PaymentForm';
import MpinVerification from 'pages/authentication/MpinVerification';
import ResetMpin from 'pages/authentication/ResetMpin';
import PrivacyPolicy from 'pages/authentication/PrivacyPolicy';
import Support from 'pages/authentication/Support';
import TermsAndConditions from 'pages/authentication/TermsAndConditions';
import DataRetentationPolicy from 'pages/authentication/DataRetentationPolicy';
import DataCollectionPolicy from 'pages/authentication/DataCollectionPolicy';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('pages/authentication/Register')));
const VerifyMobileNumber = Loadable(lazy(() => import('pages/authentication/MobileOTPVerification') ))
const ForgetPassword = Loadable(lazy(()=>import('pages/authentication/ForgetPassword')))
const KitHome = Loadable(lazy(()=>import('pages/kithome')))
const Plans =Loadable(lazy(()=> import('pages/plans/index')))
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/kithome',
      element: <KitHome />
    },
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'register',
      element: <AuthRegister />
    },
    {
        path: 'otp-verification',
        element: <VerifyMobileNumber />
    },
    {
        path: 'forget-password',
        element: <ForgetPassword />
    },
    {
        path: 'change-password',
        element: <ChangePassword />
    },
    {
        path: 'mpin-verification',
        element: <MpinVerification />
    },
    {
        path: 'reset-mpin',
        element: <ResetMpin />
    },
    {
        path:'choose-plan',
        element:<Plans />
    },
    {
        path:'payment',
        element:<PaymentForm />
    },

    {
        path:'support',
        element:<Support />
    },
    {
        path:'privacy-policy',
        element:<PrivacyPolicy />
    },
    {
        path:'terms-and-conditions',
        element:<TermsAndConditions />
    },
    {
        path:'data-collection-policy',
        element:<DataCollectionPolicy />
    },
    {
        path:'data-retention-policy',
        element:<DataRetentationPolicy />
    },

  ]
};

export default LoginRoutes;
